import { COLORS } from '@btime/constants'
import { compose, isEmpty, omit } from 'ramda'
import { useFilter, useFilterActions } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText } from '../../packages/kiti/components/presentation/Text'
import Link from '../../packages/kiti/components/actions/Link'

const CleanFilterButton = ({ ignoreFields }) => {
  const { t } = useTranslation()
  const { clearFilter, clearTempFilter } = useFilterActions()
  const filters = omit(ignoreFields || [], useFilter())
  if (isEmpty(filters)) return false

  return (
    <Link onClick={compose(clearTempFilter, clearFilter)}>
      <SmallText bold color={COLORS.red} noWrap>
        {t('cleanFilters')}
      </SmallText>
    </Link>
  )
}

export default CleanFilterButton
